<div class="flex flex-col">
  <div class="bg-grey-200 page-padding-y page-padding-x">
    <h3 id="h-standards-library">Standards Library</h3>
  </div>

  <form [formGroup]="searchForm">
    <div class="pt-6 pb-6 page-padding-x bg-grey-100">
      <div class="flex flex-col gap-6">
        <div class="flex flex-row justify-start gap-6">
          <div class="flex flex-row w-1/2">
            <div class="w-2/3">
              <label for="input-search-term-filter" class="block mb-2 text-gray-900 body-small-regular"
                id="Search Content">
                Search Content
              </label>
              <app-input id="input-search-term-filter" formControlName="searchTermCtrl" [startIcon]="searchIcon"
                placeholder="Search by Committee, Designation, Title"></app-input>
            </div>
            <div class="w-1/3 ml-4">
              <app-select-single formControlName="searchByCtrl" id="searchBy" [label]="'Search By'"
                [options]="searchByItems" [loading]="false">
              </app-select-single>
            </div>
          </div>


          <div class="flex items-center space-x-8">
            <label class="mt-2 body-default-regular" *ngIf="!isNomOrgOnly" id="myCommitteeLabel">
              <input type="radio" id="myCommitteeRadioBtn" name="publicationCommitteeTypeCtrl" value="myCommittee"
                formControlName="publicationCommitteeTypeCtrl" class="mr-1" checked
                (change)="onRadioButtonChange('myCommittee')" />
              My Committee's Publications
            </label>
            <label class="mt-2 ml-2 body-default-regular" id="allPublicationsLabel">
              <input type="radio" id="allPublicationsRadioBtn" name="publicationCommitteeTypeCtrl" value="allPublications"
                formControlName="publicationCommitteeTypeCtrl" class="mr-1" (change)="onRadioButtonChange('allPublications')" />
              All Publications
            </label>
          </div>
        </div>

        <div class="flex items-center space-x-4">
          <div class="flex flex-col w-1/4">
            <app-select-single formControlName="committeeCtrl" id="saLibraryCommittee" [label]="'Committee'"
              [options]="facetCommitteesOptionValues" [loading]="loading">
            </app-select-single>
          </div>

          <div class="flex flex-col w-1/4">
            <app-select-single formControlName="publicationTypeDropdownCtrl" id="saLibraryPublicationType"
              [label]="'Publication Type'" [options]="facetPublicationTypesOptionValues" [loading]="loading">
            </app-select-single>
          </div>

          <div class="flex flex-col w-1/4">
            <app-select-single formControlName="publicationStatusDropdownCtrl" id="saLibraryPublicationStatus"
              [label]="'Publication Status'" [options]="facetPublicationStatusesOptionValues" [loading]="loading">
            </app-select-single>
          </div>
          <button id="btn-clear-filters" class="mt-2 btn btn-neutral" (click)="clearAllFilters(false)">
            <fa-icon [icon]="faX"></fa-icon>
            Clear All Filters
          </button>
        </div>

        <div class="flex flex-row flex-wrap justify-between">
          <div class="flex flex-row justify-start gap-6">
            <app-date-picker id="dtp-start-date" formControlName="startDateCtrl" name="startDate" label="Start Date"
              placeholder="Select date" [maxDate]="maxStartDate"></app-date-picker>

            <app-date-picker id="dtp-end-date" formControlName="endDateCtrl" name="endDate" label="End Date"
              placeholder="Select date" [minDate]="minEndDate"></app-date-picker>
          </div>
        </div>
      </div>
    </div>

    <div id="document-search-results" class="py-4 bg-grey-200 page-padding-x">
      <ng-container *ngIf="
          searchResults &&
          searchResults.documents &&
          searchResults.documents.length > 0
        ">
        <div class="flex flex-row flex-wrap items-center justify-between">
          <div id="search-results-total" class="body-large-regular" >
            <span class="text-blue-600">{{
              searchResults.recordsTotal | number
              }}</span>
            available documents
          </div>

          <app-segmented-button id="btn-layout" [buttonOptions]="layoutOptions" [formControl]="layoutControl"
            class="segmented-button-med segmented-btn-orange">
          </app-segmented-button>

          <app-select id="select-sort-by" [options]="sortOptions" label="Sort By"
            formControlName="sortByCtrl"></app-select>
        </div>
      </ng-container>

      <app-document-search-results [searchResults]="searchResults" [loading]="loading"
        [layout]="selectedLayout"></app-document-search-results>

      <div *ngIf="searchResults && searchResults.recordsTotal > 0 && !loading" class="flex justify-end py-1">
        <app-pagination [totalRecords]="searchResults ? searchResults.recordsTotal : 0"
          [recordsPerPage]="searchResults ? searchResults.length : 1"
          [currentPage]="searchResults ? searchResults.page : 1" (pageChange)="onPageChange($event)"></app-pagination>
      </div>


      <div *ngIf="searchResults &&  searchResults.documents && searchResults.documents.length > 0 && !loading"
        class="flex justify-end pt-4">

        <app-back-to-top id="btn-back-to-top"></app-back-to-top>
      </div>
    </div>
  </form>
</div>
